<template>
    <v-text-field
        v-bind="$attrs"
        :value="texto"
        type="text"
        inputmode="decimal"
        v-on="ouvintes"
        @input="digitar"
        @focus="focado = true"
        @blur="sair"
    ></v-text-field>
</template>

<script>
import { numero } from '@/services/financeiroCalculos'

// <input type="number"> so aceita virgula quando o locale do navegador e pt-BR;
// nos demais o campo esvazia sozinho ao digitar "12,50". Aqui o campo e texto,
// aceita virgula ou ponto e devolve sempre numero para o v-model.
export default {
    name: 'CampoValor',
    inheritAttrs: false,

    props: {
        value: {
            type: [Number, String],
            default: null
        },
        decimais: {
            type: Number,
            default: 2
        }
    },

    data(){
        return {
            texto: this.formatar(this.value),
            focado: false
        }
    },

    computed: {
        // input/focus/blur sao tratados aqui; o resto (change, keyup...) segue direto.
        ouvintes(){
            const listeners = { ...this.$listeners }
            delete listeners.input
            delete listeners.focus
            delete listeners.blur
            return listeners
        }
    },

    watch: {
        value(valor){
            if(!this.focado){
                this.texto = this.formatar(valor)
            }
        }
    },

    methods: {
        formatar(valor){
            if(valor === null || valor === undefined || valor === ''){
                return ''
            }
            // Sem separador de milhar: "1.234" voltaria como 1,234 na releitura.
            return numero(valor).toFixed(this.decimais).replace('.', ',')
        },

        digitar(bruto){
            const texto = bruto === null || bruto === undefined ? '' : String(bruto)
            this.texto = texto
            this.$emit('input', texto.trim() === '' ? null : numero(texto))
        },

        sair(evento){
            this.focado = false
            this.texto = this.formatar(this.texto)
            this.$emit('blur', evento)
        }
    }
}
</script>
